// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductPriceDto } from "@insite/client-framework/Types/ApiModels";
import ProductDetailsState from "@store/Framework/Store/Greif/Pages/ProductDetails/ProductDetailsState";
import {
    FullTruckLoadEntryModel,
    LeadTimeEntryModel,
    MLCAvailableAtOtherShipTosModel,
} from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";

const initialState: ProductDetailsState = {
    multiLocationCatalogInfoByProductId: {},
    selectedAccessories: [],
};

export type MultiLocationCatalogInfo = {
    pricing: ProductPriceDto[];
    isMlcProduct: boolean;
    fullTruckLoads: FullTruckLoadEntryModel[];
    leadTimes: LeadTimeEntryModel[];
    availableAtOtherShipTos: MLCAvailableAtOtherShipTosModel;
};

const actions = {
    "Greif/Pages/ProductDetails/CompleteLoadMlcData": (
        draft: Draft<ProductDetailsState>,
        action: { productId: string; multiLocationCatalogInfo: MultiLocationCatalogInfo },
    ) => {
        if (!draft.multiLocationCatalogInfoByProductId) {
            draft.multiLocationCatalogInfoByProductId = {};
        }

        if (action.multiLocationCatalogInfo) {
            draft.multiLocationCatalogInfoByProductId[action.productId] = action.multiLocationCatalogInfo;
        }
    },
    "Greif/Pages/ProductDetails/SelectAccessory": (
        draft: Draft<ProductDetailsState>,
        action: { selected: boolean; product: ProductInfo },
    ) => {
        if (action.selected) {
            draft.selectedAccessories = [...draft.selectedAccessories, action.product];
        }
        if (!action.selected) {
            const data = draft.selectedAccessories.filter(item => item.productId !== action.product.productId);
            draft.selectedAccessories = data;
        }
    },
    "Greif/Pages/ProductDetails/ResetSelections": (draft: Draft<ProductDetailsState>) => {
        draft.selectedAccessories = [];
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifProductDetailPageActions = Parameters<typeof reducer>[1];
export default reducer;
